import React from "react";
import Banner from "./HomePage/Banner";
import CounterSec from "./CounterSec";
import ServicesSec from "./ServicesSec";
import ProvenSec from "./ProvenSec";
import SolutionsSec from "./SolutionsSec";
import CtaSec from "./CtaSec";

const Home = () => {
  const CounterData = [
    {
      count: "12+",
      text: "Countries Served",
    },
    {
      count: "99.9%",
      text: "System Uptime",
    },
    {
      count: "50k",
      text: "Registered Users",
    },
    {
      count: "4.9",
      text: "Average Rating",
    },
  ];
  return (
    <div className="home-page">
      <Banner />
      <CounterSec counterData={CounterData} />
      <ServicesSec />
      <ProvenSec />
      <SolutionsSec />
      <CtaSec />
    </div>
  );
};

export default Home;
